export default __webpack_public_path__ + "static/media/up_green_solid.24f1d770.svg";